module.exports = __webpack_public_path__ + "img/file1.0d91d3cd.png";